var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWiLunarEclipse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8,14.62c0-0.93,0.23-1.8,0.7-2.6s1.1-1.44,1.9-1.91s1.67-0.7,2.6-0.7c0.94,0,1.81,0.23,2.61,0.7 c0.8,0.47,1.43,1.1,1.9,1.9c0.47,0.8,0.7,1.67,0.7,2.61s-0.23,1.81-0.7,2.61c-0.47,0.8-1.1,1.43-1.9,1.9 c-0.8,0.47-1.67,0.7-2.61,0.7s-1.8-0.23-2.6-0.7c-0.8-0.47-1.43-1.1-1.9-1.9C10.03,16.43,9.8,15.56,9.8,14.62z M14.25,11.22 c0.87,0.11,1.6,0.49,2.19,1.15c0.59,0.66,0.89,1.44,0.89,2.33c0,0.83-0.26,1.56-0.78,2.2s-1.18,1.04-1.98,1.21 c0.2,0.02,0.34,0.04,0.43,0.04c0.98,0,1.81-0.35,2.5-1.04c0.69-0.69,1.04-1.52,1.04-2.5c0-0.96-0.35-1.78-1.04-2.47 c-0.69-0.68-1.53-1.02-2.5-1.02C14.74,11.14,14.49,11.17,14.25,11.22z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiLunarEclipse);
export default __webpack_public_path__ + "static/media/wi-lunar-eclipse.85606fbf230473df91169a204ac542a3.svg";
export { ForwardRef as ReactComponent };